var map = {
	"./LogoMenu.png": "f5d3",
	"./blur.svg": "4612",
	"./clock.svg": "6e22",
	"./icon-check-solid.svg": "3f9f",
	"./icon-user-request.svg": "3299",
	"./icon_aplicaciones.svg": "53fb",
	"./icon_evaluaciones.svg": "6d82",
	"./icon_interface.svg": "3760",
	"./icon_permission.svg": "100f",
	"./icon_rol.svg": "ed57",
	"./logo-training.svg": "b6fb",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./plus-square.svg": "2c11",
	"./regular-unlink.svg": "fc43",
	"./solid-lock-alt-f30d.svg": "dcf0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";